import React, { useContext, Component } from "react";
import { AuthContext } from "../../App";
import StoreDashboardV2 from "../../components/dashboard/store/StoreDashboardV2";
import SingleDashboard from "../../components/dashboard/single/SingleDashboard";

class DashboardErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error("Dashboard crash:", error, info?.componentStack);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center h-64 gap-4">
          <p className="text-red-500 font-semibold">Dashboard failed to load</p>
          <p className="text-muted-foreground text-sm max-w-md text-center">{this.state.error?.message}</p>
          <button onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700">
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

// Multi-location store accounts → location command center (Dashboard v2).
// Everyone else → the single-location command center.
const DashboardOverview = () => {
  const { user } = useContext(AuthContext);
  if (!user) return null;
  const isStoreAccount = user?.account_type === "multi_location_store";
  return (
    <DashboardErrorBoundary>
      {isStoreAccount ? <StoreDashboardV2 user={user} /> : <SingleDashboard user={user} />}
    </DashboardErrorBoundary>
  );
};

export default DashboardOverview;
